import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { AutomaticSequencing } from "../../../../../../../../../models/automatic.sequencing";
import { AutomaticSequenceOptions } from "../../../../../../../../../util/enums";
import { Input } from "../../../../../../../../../components/Form";
import useStyles from "./styles";

interface AutomaticOptionProps {
  type: string;
  isCancelled?: boolean;
  sequence?: AutomaticSequencing;
  handleChange: (sequence: AutomaticSequencing) => void;
}
export const AutomaticOption = ({
  type,
  isCancelled,
  sequence,
  handleChange,
}: AutomaticOptionProps) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [prefix, setPrefix] = useState<string>("");
  const [nextValue, setNextValue] = useState<number>();

  useEffect(() => {
    if (sequence) {
      setPrefix(sequence.prefix);
      setNextValue(sequence.nextValue);
    }
  }, [sequence]);

  useEffect(() => {
    if (isCancelled && sequence) {
      setPrefix(sequence?.prefix);
      setNextValue(sequence?.nextValue);
    }
  }, [isCancelled]);

  return (
    <div className="mt-3 w-100">
      <p className={classes.accordionDetailsSpan}>
        {type === AutomaticSequenceOptions.OPERATIONS ? translate("order") : type}
      </p>
      <Grid container direction="row" alignItems="flex-start" spacing={2}>
        <Grid item md={6} lg={6}>
          <Input
            name={`${type.toLowerCase()}-prefix`}
            label={`${translate("prefix")}`}
            value={prefix}
            onChange={(event) => {
              handleChange(
                sequence
                  ? { ...sequence, prefix: event.target.value }
                  : ({
                      type,
                      prefix: event.target.value,
                    } as AutomaticSequencing)
              );
              setPrefix(event.target.value);
            }}
          />
        </Grid>
        <Grid item md={6} lg={6}>
          <Input
            name={`${type.toLowerCase()}-next-number`}
            label={translate("nextNumber")}
            value={nextValue}
            type="text"
            onChange={(event) => {
              const rgx = /^(\s)|([0-9]+)$/;

              if (rgx.test(event.target.value) || event.target.value === "") {
                handleChange(
                  sequence
                    ? { ...sequence, nextValue: Number(event.target.value) }
                    : ({
                        type,
                        nextValue: Number(event.target.value),
                      } as AutomaticSequencing)
                );
                setNextValue(Number(event.target.value));
              }
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};
